import { ColorEnum } from '@/constants/color'
import { size } from '@/features/common/components/PersonBubble/constants'
import PersonIcon from '@/features/ui/icons/components/PersonIcon'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface PersonBubbleProps {
    width: number
    height: number
}

const PersonBubble: FC<PersonBubbleProps> = ({ width, height }) => {
    return (
        <View style={styles.container}>
            <PersonIcon width={width} height={height} fill={ColorEnum.WHITE} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.BRICK_600,
        borderRadius: size / 2,
        width: size,
        height: size,
    },
})

export default PersonBubble
